/* eslint-disable import/prefer-default-export */
export const SET_BACKGROUND_IMAGE = 'SET_BACKGROUND_IMAGE';
export const SET_USER = 'SET_USER';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js